module.exports = __webpack_public_path__ + "img/40_01_005_194.84c87574.jpg";